__turbopack_context__.v({
  "className": "inter_e12cfce1-module__pAOFRq__className",
  "variable": "inter_e12cfce1-module__pAOFRq__variable",
});
